<main class="orion-error-page tdoe-text-center">
  <app-orion-component-loader message="Logging out... Please wait."></app-orion-component-loader>
</main>